module.exports = angular.module('cartographer.map.controls', [])

_ = require 'underscore'

module.exports.directive 'crtMapControls', $DI (crtLog, crtConfig, crtLocation) ->
  return {
    restrict: 'A'
    replace: true
    template: require './controls.tpl.html'
    bindToController: true
    controllerAs: 'crtMapControls'
    scope:
      location       : '=?' # location
      zoom           : '=?' # [1,20]
      autoZoom       : '=?' # [1,20]
      mapTiles       : '=?' # or('terrain', 'satellite')
      inspectorState : '=?' # or(crtMapInspectorState, undefined)
      enableLegend   : '=?' # or(boolean, undefined)
      showLegend     : '=?' # or(boolean, undefined)
      onFindMarker   : '=?' # or((-> void), undefined)
    controller: $DI ($scope) ->
      crtMapControls = this

      # Base layer ------------------------------

      crtMapControls.mapTilesVisible  = ->
        true

      crtMapControls.mapTilesDisabled = ->
        false

      crtMapControls.mapTilesClick    = ->
        crtMapControls.mapTiles = if crtMapControls.mapTiles == 'satellite' then 'terrain' else 'satellite'
        crtMapControls.zoom     = Math.min(crtMapControls.zoom, crtMapControls.maxZoom())
        return

      crtMapControls.mapTilesSatellite = ->
        crtMapControls.mapTiles == 'satellite'

      # Zoom ------------------------------------

      # Terrain view switches black when you zoom in to level 18:
      crtMapControls.maxZoom         = -> 18

      crtMapControls.zoomInVisible   = -> !!crtMapControls.zoom
      crtMapControls.zoomInDisabled  = -> crtMapControls.zoom >= crtMapControls.maxZoom()
      crtMapControls.zoomInClick     = -> crtMapControls.zoom = Math.min(crtMapControls.zoom + 1, crtMapControls.maxZoom())

      crtMapControls.zoomOutVisible  = -> !!crtMapControls.zoom
      crtMapControls.zoomOutDisabled = -> crtMapControls.zoom <= 1
      crtMapControls.zoomOutClick    = -> crtMapControls.zoom = crtMapControls.zoom - 1

      # Find me ---------------------------------

      crtMapControls.findMeVisible   = ->
        !!crtMapControls.location

      crtMapControls.findMeWorking   = false

      crtMapControls.findMeDisabled  = ->
        !crtMapControls.location || crtMapControls.findMeWorking

      crtMapControls.findMeClick = ->
        crtMapControls.findMeWorking = true
        crtLocation
        .findMe()
        .finally ->
          crtMapControls.findMeWorking = false
          return
        .then (loc) ->
          crtMapControls.location = _.clone(loc)
          if crtMapControls.autoZoom? && crtMapControls.zoom < crtMapControls.autoZoom
            crtMapControls.zoom = crtMapControls.autoZoom
          return

      # Find marker -----------------------------

      crtMapControls.onFindMarker ?= null

      crtMapControls.findMarkerVisible = ->
        !!crtMapControls.onFindMarker

      crtMapControls.findMarkerClick = ->
        crtMapControls.onFindMarker?()
        return

      return
  }
